import * as React from 'react';
import logger from '../logger';

const TOKEN = process.env.GATSBY_IPINFO_API_TOKEN;
const isBrowser = typeof window !== 'undefined';

type Location = {
  ip: string;
  asn: string;
  as_name: string;
  as_domain: string;
  country_code: string;
  country: string;
  continent_code: string;
  continent: string;
};

export default function useLocation() {
  const [location, setLocation] = React.useState<Location | null>(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    const fetchCountry = async () => {
      try {
        const response = await fetch(`https://api.ipinfo.io/lite/me?token=${TOKEN}`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setLocation(data);
      } catch (e) {
        setError(e instanceof Error ? e.message : 'Unknown error');
        logger.error('Error fetching user country data', e);
      } finally {
        setLoading(false);
      }
    };

    if (isBrowser) {
      fetchCountry();
    }
  }, []);

  return { location, loading, error };
}
